module.exports = __webpack_public_path__ + "static/service-2-278ace602dc6d24b39ba93e10f09f7f0.png";